import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
    CancelBtn,
    InputGroup,
    Label,
    Note,
    SideCancelBtn,
    SubmitBtn,
} from "../../Styles/InputStyles";
import Model from "../../Model";

const validationSchema = Yup.object({
    rentalCycle: Yup.string()
        .required("Rental cycle day is required")
        .test(
            'is-valid-day',
            'Rental cycle day must be a number between 1 and 31',
            (value) => {
                if (!value) return false;
                const num = Number(value);
                return Number.isInteger(num) && num >= 1 && num <= 31;
            }
        ),
});

const ChangeRentalCycle = ({
    setIsRentalCycle,
    selectedData,
    changeRentalCycleLoading,
    changeRentalCycleMutate
}) => {
    const initialValues = {
        rentalCycle: selectedData?.data?.occupancy?.rentalCycle?.toString() || "",
        id: selectedData?.data?.id,
    };

    const handleSubmit = (values, { setSubmitting }) => {
        changeRentalCycleMutate({
            tenantId: selectedData?.data?.id,
            rentalCycle: parseInt(values.rentalCycle, 10), // Convert to number
        });
        setSubmitting(false);
    };

    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setIsRentalCycle}
            title="Change Rental Cycle"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ isSubmitting }) => (
                    <Form>
                        <InputGroup>
                            <Label>Rental Cycle</Label>
                            <Field
                                type="text"
                                name="rentalCycle"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter day (1-31)"
                            />
                            <ErrorMessage
                                name="rentalCycle"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 my-4">
                            <SideCancelBtn
                                type="button"
                                onClick={() => setIsRentalCycle(false)}
                            >
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn
                                type="submit"
                                disabled={isSubmitting || changeRentalCycleLoading}
                            >
                                {changeRentalCycleLoading ? "Saving..." : "Save"}
                            </SubmitBtn>
                        </div>

                        <Note>Enter a number between 1 and 31 to set rental cycle.</Note>
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

export default ChangeRentalCycle;